var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiamWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 42,
    viewBox: "0 0 183 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7954 18.54C46.7915 16.14 48.0244 13.38 48.0244 10.68C48.0244 4.32 45.1477 0 35.8128 0H0V42H37.5741C46.9089 42 50.9599 36.48 50.9599 29.58C50.9599 25.02 48.3767 21.18 44.7954 18.54ZM15.2645 10.2H29.3548C30.8812 10.2 32.7599 10.2 32.7599 12.48C32.7599 14.76 30.8812 14.76 29.3548 14.76H15.2645V10.2ZM32.2903 30.6H15.2645V26.16H32.2903C33.8167 26.16 35.6954 26.16 35.6954 28.38C35.6954 30.6 33.8167 30.6 32.2903 30.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.663 0H50.3985V42H65.663V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.414 42H121.205L104.179 0H81.5168L64.4911 42H81.282L84.1001 34.44H101.596L104.414 42ZM88.0923 23.64L92.8478 10.8L97.6033 23.64H88.0923Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183 0H164.213L151.532 24L138.85 0H120.063V42H135.328V22.02L146.541 42H156.522L167.736 22.02V42H183V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiamWhite);
export default __webpack_public_path__ + "static/media/biam_white.f4350b0ba97a58a9f47e8b446a149af8.svg";
export { ForwardRef as ReactComponent };